import type { ReactNode } from 'react';
import { cn } from '../../lib/utils';

export type BadgeVariant = 'default' | 'outline' | 'blue' | 'green' | 'yellow' | 'orange' | 'red' | 'purple';

interface BadgeProps {
  children: ReactNode;
  variant?: BadgeVariant;
  className?: string;
}

const variantStyles: Record<BadgeVariant, string> = {
  default: 'bg-bg-tertiary text-text-primary border-border-default',
  outline: 'bg-transparent text-text-secondary border-border-default',
  blue: 'bg-accent-blue/20 text-accent-blue border-accent-blue/30',
  green: 'bg-accent-green/20 text-accent-green border-accent-green/30',
  yellow: 'bg-accent-yellow/20 text-accent-yellow border-accent-yellow/30',
  orange: 'bg-accent-orange/20 text-accent-orange border-accent-orange/30',
  red: 'bg-accent-red/20 text-accent-red border-accent-red/30',
  purple: 'bg-accent-purple/20 text-accent-purple border-accent-purple/30',
};

export function Badge({ children, variant = 'default', className }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium border',
        variantStyles[variant],
        className
      )}
    >
      {children}
    </span>
  );
}

